import { resolveAvatarUrl } from './avatarUtils';

// The art behind a player's profile. The chosen background id is
// always a Site card's unique_id: either a basic realm (free for
// everyone) or a Site unlocked through a Realm Pack. Anything else
// (legacy non-Site backgrounds from before the Sites-only rule, or a
// missing entry) falls back to the player's avatar art so there is
// always a backdrop.
//
// Both the URL and an `isSite` flag are returned because Sites are
// played horizontally: their portrait image file has to be rotated
// 90 degrees to read as a landscape backdrop, while the avatar
// fallback renders in its native portrait orientation.
//
// Shared by the profile overlay's hero and the hub's player rows,
// which reveal the same art on hover.
export function resolveProfileBackdrop(player, sorceryCards) {
  if (!player) return null;
  const bgId = player.backgroundCardId;
  if (bgId && Array.isArray(sorceryCards)) {
    const card = sorceryCards.find((c) => c.unique_id === bgId);
    if (card?.type === 'Site') {
      const url = card.printings?.[0]?.image_url;
      if (url) return { url, isSite: true };
    }
  }
  const fallbackUrl = resolveAvatarUrl(player, sorceryCards);
  return fallbackUrl ? { url: fallbackUrl, isSite: false } : null;
}
